import { Modal, Input, MultiSelect, Avatar } from '@mantine/core';
import { useState } from 'react';
import PrimaryButton from 'components/primaryButton';
import { Controller, useForm } from 'react-hook-form';
import { ReactComponent as CrossIcon } from 'assets/icons/crossIcon.svg';
// import crossicon from 'assets/icons/crossicon5.svg';
import { useWindowSize } from 'react-use';
import { ReactComponent as DownArrow } from 'assets/icons/downArrow.svg';
import useGetEmployeesList from 'pages/projects/pages/myProjects/hooks/useGetEmployeesList';
import useCreateMailsFolder from '../hooks/useCreateMailsFolder';

const Createfoldermodel = (props) => {
  const { opened, setOpened } = props;
  const { width } = useWindowSize();
  const closeModal = () => {
    setOpened(false);
    reset();
  };
  const usecreatemailsfolder = useCreateMailsFolder(closeModal);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: '',
      sender_mails: [],
    },
  });

  //onsubmit
  const onSubmit = (data) => {
    // console.log(data);
    usecreatemailsfolder.mutate(data);
  };

  //on close

  //model size
  function modelsize() {
    if (width >= 1280 && width <= 1535) {
      return 'lg';
    } else if (width >= 1536) {
      return 'xl';
    } else {
      return 'lg';
    }
  }
  const size1 = modelsize();

  //form error
  const errorMessage = (name) => {
    return (
      errors[name] && (
        <p className='text-[#fc0101] text-sm font-bold 2xl:text-lg 3xl:text-xl'>
          {errors[name]?.message}
        </p>
      )
    );
  };
  const getEmployeesList = useGetEmployeesList();
  //   custom dropdown item for select
  const SelectItem = ({
    activeStatus,
    value,
    label,
    image,
    name,
    description,
    ...others
  }) => {
    return (
      <div className={`flex px-5 `}>
        <div
          {...others}
          className={`flex items-center py-2 cursor-pointer  ${
            activeStatus ? '' : 'opacity-60'
          } `}
        >
          <Avatar src={image} color='red'>
            {label?.[0]?.toUpperCase()}
          </Avatar>
          <div className='pl-1 '>
            <p className='text-18 '>{label} </p>
            <p className='text-xs text-gray3 pt-1 '>{value} </p>
          </div>
        </div>

        <p className='ml-auto'>
          {activeStatus ? (
            <span className='ml-3 text-[12px] text-[#28B446] bg-[#c1f3cc] py-1 px-2 rounded-lg '>
              Active
            </span>
          ) : (
            <span className='ml-3 text-[12px] text-[#D0342C] bg-[#f7bab6] py-1 px-2 rounded-lg'>
              Inactive
            </span>
          )}
        </p>
      </div>
    );
  };

  const [data, setData] = useState([]);
  //   dropdown values for team member multi select input
  const getDropdownData = () => {
    const dataArray = [];

    getEmployeesList?.data?.data?.forEach((employee) => {
      dataArray.push({
        activeStatus: employee?.user__is_active,
        image: employee?.profile_picture,
        label: employee.user__first_name,
        value: `${employee?.user__email}`,
        description: employee?.designation__name,
        disabled: employee?.user__is_active ? false : true,
      });
    });
    return dataArray?.concat(data);
  };

  return (
    <div>
      <Modal
        opened={opened}
        onClose={() => closeModal()}
        size={size1}
        centered
        withCloseButton={false}
        transitionDuration={100}
        overlayBlur={20}
        overlayOpacity={0.5}
        overlayColor={'#F8F7F799'}
        overflow='inside'
        className='rounded-[13px]'
        classNames={{
          body: 'scroller h-auto',
        }}
      >
        <div className='flex items-center'>
          <h1 className='w-full text-center font-semibold mx-auto  text-xl text-333333 2xl:text-2xl 3xl:text-3xl'>
            Create folder
          </h1>
          <CrossIcon
            className='w-14 ml-auto cursor-pointer 2xl:w-16 3xl:w-18'
            onClick={() => closeModal()}
          />
        </div>

        <form
          className='flex flex-col py-4 px-2'
          onSubmit={handleSubmit(onSubmit)}
        >
          <label className='text-sm text-neutralsGrey 2xl:text-lg 3xl:text-xl'>
            Name of the folder
          </label>

          <Controller
            name='name'
            control={control}
            rules={{ required: 'required' }}
            render={({ field }) => (
              <Input
                {...field}
                placeholder='Enter the folder name'
                size='md'
                classNames={{
                  input:
                    'bg-transparent border-primary text-lg rounded pl-5 mt-2 2xl:text-xl 3xl:text-2xl',
                  placeholder:
                    'text-neutralsGrey text-xs font-normal ml-2 2xl:text-xs 3xl:text-sm',
                }}
              />
            )}
          />
          {errorMessage('name')}

          <label className='text-sm text-neutralsGrey mt-8 2xl:text-lg 3xl:text-xl'>
            Add mails for these senders to folder
          </label>

          <Controller
            name='sender_mails'
            control={control}
            rules={{ required: 'required' }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                size='md'
                itemComponent={SelectItem}
                placeholder='Enter email(s)'
                searchable
                creatable
                onCreate={(query) => {
                  const item = { value: query, label: query };
                  setData((current) => [...current, item]);
                  return item;
                }}
                getCreateLabel={(query) => `Use this address: ${query}`}
                data={
                  !getEmployeesList?.data?.data?.length ? [] : getDropdownData()
                }
                rightSection={<DownArrow />}
                styles={{ rightSection: { pointerEvents: 'none' } }}
                classNames={{
                  input: 'border-primary truncate min-h-[7vh]',
                  label: 'text-neutralsGrey text-sm',
                }}
              />
            )}
          />
          {errorMessage('sender_mails')}

          <button
            className='mt-8 w-20 m-auto 2xl:w-28 2xl:text-lg 3xl:text-xl 3xl:w-32'
            type='submit'
          >
            <PrimaryButton>Save</PrimaryButton>
          </button>
        </form>
      </Modal>
    </div>
  );
};

export default Createfoldermodel;
